import { useState } from 'react';
import { Link } from 'react-router-dom';
import { SectionLabel } from '../components/Effects';
import { ArrowIcon } from '../components/Icons';
import { discordRules, economyRules, type RuleItem } from '../data/rules';

type Language = 'en' | 'si' | 'both';

export function RulesPage() {
  const [language, setLanguage] = useState<Language>('both');
  return <>
    <section className="rules-hero page-hero">
      <div className="rules-pattern"/>
      <div className="page-hero-copy"><div className="eyebrow"><span/> OFFICIAL CIVIC RECORD / SEASON III</div><h1>The Constitution<br/><em>of our world.</em></h1><p>Clear law. Fair play. One standard for every citizen.</p><div className="language-switch" role="group" aria-label="Language"><button className={language==='en'?'active':''} onClick={()=>setLanguage('en')}>🇬🇧 English</button><button className={language==='si'?'active':''} onClick={()=>setLanguage('si')}>🇱🇰 සිංහල</button><button className={language==='both'?'active':''} onClick={()=>setLanguage('both')}>🌐 Both</button></div></div>
      <div className="constitution-seal"><img src="/assets/ugeappage-logo-zoomed.webp" alt="Uge Appage SMP"/><span>OFFICIAL</span><b>III</b><small>CONSTITUTION</small></div>
    </section>

    <div className="rules-nav"><a href="#discord">I. Discord Community</a><a href="#smp">II. SMP & Economy</a><span>LAST RATIFIED · SEASON III</span></div>

    <section id="discord" className="rules-section section-pad">
      <SectionLabel index="SECTION I">COMMUNITY CODE</SectionLabel>
      <div className="split-heading" data-reveal><h2>Discord Community<br/><em>Rules.</em></h2><p>Our world starts before you log in. The community space is governed by the same respect expected in-game.</p></div>
      <div className="rule-list">{discordRules.map((rule) => <RuleCard key={rule.titleEn} rule={rule} language={language}/>)}</div>
    </section>

    <section id="smp" className="rules-section dark section-pad">
      <SectionLabel index="SECTION II">SMP & ECONOMY LAW</SectionLabel>
      <div className="split-heading" data-reveal><h2>The laws that keep<br/><em>the world alive.</em></h2><p>Markets, machines, public space, and fair play—structured so every citizen's effort matters.</p></div>
      <div className="rule-list economy-rules">{economyRules.map((rule) => <RuleCard key={rule.titleEn} rule={rule} language={language}/>)}</div>
    </section>

    <section className="rules-pledge section-pad"><div data-reveal><img src="/assets/ugeappage-logo-zoomed.webp" alt="Uge Appage SMP"/><small>CITIZEN PLEDGE</small><h2>Respect the world.<br/>Respect the people building it.</h2><p>By applying, you confirm that you have read and accepted this Constitution in full.</p><Link className="primary-btn enchant" to="/">Return to citizenship portal <ArrowIcon/></Link></div></section>
  </>;
}

function RuleCard({ rule, language }: { rule: RuleItem; language: Language }) {
  const [open, setOpen] = useState(true);
  return <article className={`rule-card ${open?'open':''}`} data-reveal>
    <button onClick={()=>setOpen(!open)} aria-expanded={open}><span className="rule-icon">{rule.icon}</span><div>{language!=='si' && <h3>{rule.titleEn}</h3>}{language!=='en' && <h4>{rule.titleSi}</h4>}</div><i>{open?'−':'+'}</i></button>
    {open && <div className={`rule-body ${language}`}>
      {language!=='si' && <div><small>ENGLISH</small><p>{rule.en}</p></div>}
      {language!=='en' && <div><small>සිංහල</small><p lang="si">{rule.si}</p></div>}
    </div>}
  </article>;
}
